<template>
    <aside class="px-0 py-6 sm:px-6 lg:col-span-3 lg:px-0 lg:py-0">
        <nav class="space-y-1 sticky top-20">
            <router-link v-for="item in subNavigation" :key="item.name" :to="item.href" :class="[item.route.includes(currentSection) ? 'bg-white text-blue-600 hover:bg-white' : 'text-gray-900 hover:bg-gray-50 hover:text-gray-900', 'group flex items-center rounded-md px-3 py-2 text-sm font-medium']" :aria-current="item.route.includes(currentSection) ? 'page' : undefined">
                <component :is="item.icon" :class="[item.route.includes(currentSection) ? 'text-blue-600' : 'text-gray-400 group-hover:text-gray-500', 'mr-3 -ml-1 size-6 shrink-0']" aria-hidden="true" />
                <span class="truncate">{{ $t(item.name) }}</span>
            </router-link>
        </nav>
    </aside>
</template>

<script lang="ts">
import {defineComponent} from 'vue';

import {mapGetters} from "vuex";
import {CogIcon, CreditCardIcon, UserCircleIcon} from "@heroicons/vue/24/outline";

export default defineComponent({
    name: "ControlsMenuComponent",

    data() {
        return {
            subNavigation: [
                { name: 'controls_menu.profile', href: '/profile', icon: UserCircleIcon, route: ['user.profile'] },
                { name: 'controls_menu.settings', href: '/settings', icon: CogIcon, route: ['user.settings'] },
                { name: 'controls_menu.subscription', href: '/subscription', icon: CreditCardIcon, route: ['user.subscription'] },
            ],
        };
    },

    computed: {
        ...mapGetters({
            user: "user/user"
        }),

        currentSection(): string {
            return this.$route.name as string;
        },
    },

    methods: {
        //
    }
})
</script>

<style scoped>

</style>